import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId:              process.env.REACT_APP_CLIENT_ID || "00000000-0000-0000-0000-000000000000",
    authority:             `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "common"}`,
    redirectUri:           window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || process.env.NODE_ENV !== "development") return;
        console.log(`[MSAL] ${message}`);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = { scopes: ["User.Read", "openid", "profile", "email"] };

export const msalInstance = new PublicClientApplication(msalConfig);

export const getInitials = name => {
  if (!name) return "?";
  const p = name.trim().split(" ");
  return p.length >= 2 ? `${p[0][0]}${p[p.length-1][0]}`.toUpperCase() : name.slice(0,2).toUpperCase();
};

export function getUserRoles(accounts) {
  const account = accounts?.[0];
  if (!account) return [];
  return account?.idTokenClaims?.roles || [];
}

export function isAdmin(accounts) {
  return getUserRoles(accounts).includes("Admin");
}